
// src/connects/group-kpi-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'
import { trackPage, trackHandlers } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import config from '../config'
import { mergeArray, deleteArray } from '../helpers/store'

export const mapStateToProps = (state)=> {
  return {
    kpis: state.kpi.items,
    closedKpis: state.kpi.closedItems,
    isFetching: state.kpi.isFetching,
    hasMoreClosedKpis: state.kpi.hasMoreClosedItems,
    access_token: state.sessions.access_token,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    fetchKpis: (props)=> dispatch(actions.fetchKpis(props.group.group_id)),
    sortKpis: (props, sort) => dispatch(actions.sortKpis(sort, props.group.group_id)),
    fetchClosedKpis: (props, refresh = false)=> dispatch(actions.fetchClosedKpis(props.group.group_id, refresh ? 0 : props.closedKpis && props.closedKpis.length || 0)),
    editKpi: (props, kpi_id)=> ownProps.selectPanel('kpi', 'edit', { kpi_id: kpi_id }),
    newKpi: (props, cloneKpi = undefined, nextPeriod = false)=> ownProps.selectPanel('kpi', 'new', { kpi_id: undefined, type: 'group', id: props.group.group_id, cloneKpi, nextPeriod }),
    deleteKpi: (kpi)=> {
      dispatch(actions.deleteKpi(kpi.kpi_id))
      dispatch(emitAlertMessage({ message: 'label:KPIを削除しました', name: kpi.name }, 'success'))
    },
    pushKpi: (props, kpi)=> {
      props.updateUI({ checkKpi: mergeArray('kpi_id', props.ui.checkKpi, [kpi])})
    },
    exclusionKpi: (props, kpi)=> {
      props.updateUI({ checkKpi: deleteArray('kpi_id', props.ui.checkKpi, kpi.kpi_id) })
    },
    notKpiMessage: ()=> dispatch(emitAlertMessage('label:KPIが選択されていません', 'error')),
    willMount: (props)=> dispatch(actions.fetchKpis(props.group.group_id)),
    willUnmount: (props)=> dispatch(actions.fetchDiaryKpi(props.group.group_id, new Date())),
    startSorting: ()=> {
      dispatch(emitAlertMessage('label:ドラッグして並べ替え', 'success'))
    },
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    downloadUrl: (kpi_id)=> `${config.baseUrl}v3/export/kpi_status.xlsx?kpi_id=${kpi_id}&access_token=${stateProps.access_token}`,
  })
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle,
  ui({ state: { showClosedKpi: false, onCheck: false, checkKpi: undefined }}),
  translate(),
  trackPage('group_kpi'),
  trackHandlers('editKpi', 'group_kpi_edit'),
  trackHandlers('newKpi', 'group_kpi_new'),
)



// WEBPACK FOOTER //
// ./src/connects/group-kpi-panel.js